import { Injectable, NgZone, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

import { BehaviorSubject, Observable, debounceTime, filter, map, take } from 'rxjs';

const CONTENT_STABLE_TIME = 100;

@Injectable({
    providedIn: 'root',
})
export class ContentReadyService {
    readonly #router = inject(Router);
    readonly #ngZone = inject(NgZone);

    readonly #contentReadyTrigger$ = new BehaviorSubject<boolean>(false);

    /**
     * Observable that emits when the first content ready trigger is received after a navigation.
     */
    get contentStart(): Observable<void> {
        return this.#ngZone.runOutsideAngular(() =>
            this.#contentReadyTrigger$.pipe(
                filter((value) => value),
                debounceTime(0), // wait for paint
                map(() => {}),
                take(1),
            ),
        );
    }

    /**
     * Observable that emits when the last content ready trigger is received after a navigation.
     */
    get contentStable(): Observable<void> {
        return this.#ngZone.runOutsideAngular(() =>
            this.#contentReadyTrigger$.pipe(
                filter((value) => value),
                debounceTime(CONTENT_STABLE_TIME),
                map(() => {}),
                take(1),
            ),
        );
    }

    constructor() {
        this.#router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => {
            this.#contentReadyTrigger$.next(false);
        });
    }

    trigger() {
        this.#contentReadyTrigger$.next(true);
    }
}
